import { ApiCore } from "./ApiCore";
import { Account, User } from "../../types";

export class SendumApi {
	private static _apiClient: ApiCore;

	public static get apiClient(): ApiCore {
		if (!SendumApi._apiClient) {
			throw new Error("API Client is not initiated");
		}

		return SendumApi._apiClient;
	}

	public static set apiClient(client: ApiCore) {
		SendumApi._apiClient = client;
	}

	public static async getSupportAccountList(): Promise<Account[]> {
		return await SendumApi.apiClient.get("support/account/list") as unknown as Account[];
	}

	public static async getSupportUserList(): Promise<User[]> {
		return await SendumApi.apiClient.get("support/user/list") as unknown as User[];
	}

	public static async setHUG(objectType: "account" | "user", objectId: string, value: boolean): Promise<void> {
		await SendumApi.apiClient.post("support/set-hug", { objectType, objectId, value });
	}

	public static async setSupport(UserName: string, value: boolean): Promise<void> {
		await SendumApi.apiClient.post("support/set-support", { UserName, value });
	}

	public static async setSuperuser(UserName: string, value: boolean): Promise<void> {
		await SendumApi.apiClient.post("support/set-superuser", { UserName, value });
	}
}
